<template>
	<!-- <div> -->
	<v-card elevation="0">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add') }} {{ $t('device-template') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense>
				<!-- Type / Manufacturer -->
				<v-col cols="12">
					<v-select
						:items="deviceTypes"
						item-value="lowValue"
						item-text="longDescription"
						outlined
						dense
						:label="$t('device-type')"
						v-model="device.deviceType"
						hide-details></v-select>
				</v-col>

				<v-col cols="12">
					<v-select
						:items="deviceManufacturers"
						item-value="lowValue"
						item-text="longDescription"
						outlined
						dense
						v-model="device.manufacturerId"
						:label="$t('device-manufacturers')"
						hide-details="auto"
						:error-messages="
							isDuplicateTemplate ? [$t('template-with-same-device-type-and-manufacturer-already-exists')] : []
						"></v-select>
				</v-col>
				<v-col cols="12">
					<v-text-field hide-details v-model="device.deviceIdentifier" label="Device Identifier" outlined dense />
				</v-col>

				<!-- Notification -->
				<v-col cols="12" class="mt-5">
					<v-text-field
						hide-details
						v-model="device.notificationServiceUDID"
						label="Notification Service UDID"
						outlined
						dense />
				</v-col>

				<v-col cols="12">
					<v-text-field
						hide-details
						v-model="device.notificationCharacteristicsUDID"
						label="Notification Characteristics UDID"
						outlined
						dense />
				</v-col>
				<!-- Read -->
				<v-col cols="12" class="mt-5">
					<v-text-field hide-details v-model="device.readServiceUDID" label="Read Service UDID" outlined dense />
				</v-col>

				<v-col cols="12">
					<v-text-field
						hide-details
						v-model="device.readCharacteristicsUDID"
						label="Read Characteristics UDID"
						outlined
						dense />
				</v-col>

				<!-- Write -->
				<v-col cols="12" class="mt-5">
					<v-text-field hide-details v-model="device.writeServiceUDID" label="Write Service UDID" outlined dense />
				</v-col>

				<v-col cols="12">
					<v-text-field
						hide-details
						v-model="device.writeCharacteristicsUDID"
						label="Write Characteristics UDID"
						outlined
						dense />
				</v-col>

				<!-- JSON fields -->
				<v-col cols="12" class="mt-5">
					<v-textarea
						hide-details
						v-model="device.additionalParamsJson"
						label="Additional Params (JSON)"
						outlined
						rows="3"
						auto-grow />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="isSaveButtonDisabled" @click="saveDeviceTemplate">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'AddInventoryConsumable',
	data () {
		return {
			loading: false,
			device: {
				deviceType: -1,
				manufacturerId: -1,
				deviceIdentifier: '',
				notificationServiceUDID: null,
				notificationCharacteristicsUDID: null,
				readServiceUDID: null,
				readCharacteristicsUDID: null,
				writeServiceUDID: null,
				writeCharacteristicsUDID: null,
				additionalParamsJson: '',
				status: 1,
			},
			deviceTypes: [],
			deviceManufacturers: [],
		};
	},
	methods: {
		...mapActions({
			addMedicalDeviceTemplate: 'medicaldevice/addMedicalDeviceTemplate',
			getVerifiersForDomain: 'verifiers/getVerifiersForDomain',
		}),
		closeDrawer () {
			this.device = {
				deviceType: -1,
				manufacturerId: -1,
				deviceIdentifier: '',
				notificationServiceUDID: null,
				notificationCharacteristicsUDID: null,
				readServiceUDID: null,
				readCharacteristicsUDID: null,
				writeServiceUDID: null,
				writeCharacteristicsUDID: null,
				additionalParamsJson: '',
				status: 1,
			};
			this.$store.commit('SET_DETAIL_DRAWER_STATE', false);
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async saveDeviceTemplate () {
			try {
				if (this.device.notificationServiceUDID === null) {
					this.device.notificationServiceUDID = crypto.randomUUID();
				}
				if (this.device.notificationCharacteristicsUDID === null) {
					this.device.notificationCharacteristicsUDID = crypto.randomUUID();
				}
				const saveMedicalDeviceTemplateResponse = await this.addMedicalDeviceTemplate(this.device);
				if (saveMedicalDeviceTemplateResponse) {
					this.closeDrawer();
				}
			} catch {
				alert(this.$t('could-not-generate-uuid-please-update-browser'));
			}
		},
		async getVerifiers (domainValue) {
			const header = { domainValue };
			return await this.getVerifiersForDomain(header);
		},
	},
	computed: {
		...mapState({
			medicalDeviceTemplates: (state) => state.medicaldevice.medicalDeviceTemplates,
			selectedDeviceTemplate: (state) => state.medicaldevice.selectedDeviceTemplate,
			detailsDrawer: (state) => state.detailsDrawer,
		}),
		selectedConsumableCatalog () {
			return this.$store.state.inventoryConsumableCatalogs.selectedConsumableCatalog;
		},
		formattedExpirationDate () {
			return this.itemModel.expirationDate ? this.formatTimestamp(this.itemModel.expirationDate) : '';
		},
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		isDuplicateTemplate () {
			if (!this.device.deviceType || !this.device.manufacturerId) return false;

			return this.medicalDeviceTemplates.some(
				(template) =>
					template.deviceType === this.device.deviceType && template.manufacturerId === this.device.manufacturerId,
			);
		},
		isSaveButtonDisabled () {
			const d = this.device;

			const result = !(
				Number(d.deviceType) > 0 &&
				d.deviceIdentifier &&
				d.additionalParamsJson &&
				Number(d.manufacturerId) > 0 &&
				Number(d.status) > 0
			);
			return result || this.isDuplicateTemplate;
		},
	},
	async mounted () {
		const deviceManufacturerResponse = await this.getVerifiers('MEDICAL_DEVICE_MANUFACTURER');
		this.deviceManufacturers = deviceManufacturerResponse;

		const deviceTypeResponse = await this.getVerifiers('DEVICE_TYPE');
		this.deviceTypes = deviceTypeResponse;
	},
};
</script>
